export const inputClass =
  'border border-iq-grey-light rounded-lg px-3 py-2.5 text-sm text-iq-black placeholder:text-iq-grey-medium focus:outline-none focus:border-iq-grey-medium transition-colors';

export function FormField({label, children}: {label: string; children: React.ReactNode}) {
  return (
    <div className='flex flex-col gap-1.5'>
      <label className='text-sm font-semibold text-iq-black'>{label}</label>
      {children}
    </div>
  );
}
